import React, { useContext, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import styles from "./MultiUpload.module.css";
import { toast } from "react-toastify";
import AuthContext from "../../store/auth-context";
import { useParams } from "react-router";

const cleanFileName = (name) => {
    return name
        .toLowerCase()
        .replace(/[^a-z0-9.\-_]/g, "-")
        .replace(/-+/g, "-");
};

const MultiUpload = () => {
    const authCtx = useContext(AuthContext);
    const [uploads, setUploads] = useState([]);
    const [dragOver, setDragOver] = useState(false);
    const [isUploading, setIsUploading] = useState(false)
    const [userContentType, setUserContentType] = useState('')
    const { userId } = useParams()
    console.log("this is at multi-upload : ", userId, authCtx?.userIdentifier)

    const handleFileSelection = (filesList) => {
        const selected = Array.from(filesList).map((file) => ({
            file,
            progress: 0,
            cloudFrontURL: "",
            error: null,
        }));
        setUploads(selected);
    };

    const handleFileChange = (e) => handleFileSelection(e.target.files);

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragOver(true);
    };

    const handleDragLeave = () => setDragOver(false);

    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        handleFileSelection(e.dataTransfer.files);
    };

    const uploadFile = async (item) => {
        const fileSizeBytes = item.file.size;
        const fileType = item.file.type;
        // console.log(fileSizeBytes, fileType)
        // console.log(item)
        // return;
        try {
            const cleanedName = cleanFileName(item.file.name);
            const key = `uploads/stylelink-stylist-cdn/${userId}/${Date.now()}-${cleanedName}`;

            const { data } = await axios.get(
                "https://bucket-api.lokaci.com/generate-presigned-url-stylelink",
                {
                    params: {
                        fileName: key,
                        contentType: item.file.type,
                        stylistIdentifier: userId,
                        executiveIdentifier: authCtx?.userIdentifier,
                        userContentType: userContentType,
                        fileSizeBytes : fileSizeBytes,
                        fileType : fileType
                    },
                }
            );

            const { uploadURL, cloudFrontURL } = data;

            await axios.put(uploadURL, item.file, {
                headers: { "Content-Type": item.file.type },
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    setUploads((prev) =>
                        prev.map((u) =>
                            u.file === item.file ? { ...u, progress: percent } : u
                        )
                    );
                },
            });

            setUploads((prev) =>
                prev.map((u) =>
                    u.file === item.file ? { ...u, cloudFrontURL, progress: 100 } : u
                )
            );
        } catch (err) {
            console.error(err);
            setUploads((prev) =>
                prev.map((u) =>
                    u.file === item.file ? { ...u, error: "Upload failed" } : u
                )
            );
        }
    };

    const handleUploadAll = async () => {
        setIsUploading(true);

        const uploadPromises = uploads
            .filter((item) => !item.cloudFrontURL && !item.error)
            .map((item) => uploadFile(item));

        await Promise.all(uploadPromises);
        setIsUploading(false);
    };


    return (
        <div className={styles.mainWrapper}>
            <motion.div
                className={styles.headerWrapper}
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
            >
                <h2 className={styles.title}>Upload Candidate Content</h2>
                <p className={styles.subtitle}>
                    Drag & drop your images or click to browse. Files will be uploaded
                    securely to Stylelink CDN.
                </p>
            </motion.div>

            <motion.div
                className={`${styles.bodyWrapper} ${dragOver ? styles.dragActive : ""}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                whileHover={{ scale: 1.02 }}
            >
                <div className={styles.uploadZone}>
                    <input
                        id="fileUpload"
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleFileChange}
                        className={styles.hiddenInput}
                    />
                    <label htmlFor="fileUpload" className={styles.uploadLabel}>
                        <motion.div
                            className={styles.uploadContent}
                            animate={{ scale: dragOver ? 1.1 : 1 }}
                        >
                            <img
                                src="https://d26wg3m90fktzo.cloudfront.net/uploads/001721807041000002/1760946685450-upload-icon-logo-transparent.png"
                                alt="upload"
                                className={styles.uploadIcon}
                            />
                            <p>
                                <strong>Drag & drop</strong> files here or <span>browse</span>
                            </p>
                        </motion.div>
                    </label>
                </div>
            </motion.div>

            {uploads.length > 0 && (
                <div className={styles.uploadListWrapper} >
                    <div className={styles.uploadActionBtn} >
                        <div className={styles.itemSelected}>
                            {uploads?.length} items selected!
                        </div>
                        {isUploading === true ?
                            <button
                                className={styles.uploadAllBtn}
                                disabled={true}
                            >
                                Uploading...
                            </button>
                            :
                            <button
                                className={styles.uploadAllBtn}
                                onClick={handleUploadAll}
                                disabled={uploads.length === 0}
                            >
                                Upload All
                            </button>
                        }
                    </div>
                    <div className={styles.uploadList}>

                        <AnimatePresence>
                            {uploads?.map((item, idx) => (
                                <motion.div
                                    key={idx}
                                    className={styles.fileCard}
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: 20 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <div className={styles.fileInfo}>
                                        <p className={styles.fileName}>{item.file.name}</p>
                                        <p className={styles.fileSize}>
                                            {(item.file.size / 1024).toFixed(1)} KB
                                        </p>
                                    </div>

                                    <div className={styles.progressBar}>
                                        <motion.div
                                            className={styles.progress}
                                            initial={{ width: 0 }}
                                            animate={{ width: `${item.progress}%` }}
                                            transition={{ duration: 0.4 }}
                                        />
                                    </div>

                                    {item.error && <p className={styles.error}>{item.error}</p>}
                                    {item.cloudFrontURL && (
                                        <div className={styles.previewWrapper}>
                                            <img
                                                src={item.cloudFrontURL}
                                                alt="uploaded"
                                                className={styles.previewImg}
                                            />
                                            <a
                                                href={item.cloudFrontURL}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={styles.urlLink}
                                            >
                                                View File
                                            </a>
                                        </div>
                                    )}
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MultiUpload;
